













































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import rules from "../../utils/rules";

@Component
export default class UpdateUserDialog extends Vue {
  @Prop() user!: any;
  @Prop() dialogUpdate!: boolean;

  $refs!: {
    formUpdate: HTMLFormElement;
  };

  emailRules = [rules.email];
  generalRules = [rules.notEmpty];
  validUpdate = true;
  loadingUpdate = false;
  snackbarSuccesUpdate = false;
  snackbarErrorUpdate = false;

  private cancelUpdate(): void {
    this.$refs.formUpdate.reset();
    this.$emit("cancelUpdate");
  }

  private updateUser(): void {
    this.loadingUpdate = true;
    this.$store
      .dispatch("user/updateUser", this.user)
      .then((response: boolean) => {
        if (response) {
          this.snackbarSuccesUpdate = true;
        } else {
          this.snackbarErrorUpdate = true;
        }
        this.loadingUpdate = false;
        this.$emit("cancelUpdate");
        this.$refs.formUpdate.reset();
      });
  }

  private get allStatus(): Array<string> {
    return this.$store.getters["common/getStatus"];
  }

  private get allRoles(): Array<string> {
    return this.$store.getters["common/getRoles"];
  }
}
